const waitForFilters = (element, callback) => {
    const maxWaitTime = 20000;
    const interval = 90;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
        const selector = document.querySelector(element);
        if (selector) {
            callback();
            clearInterval(waitingInterval);
        } else {
            elapsedTime += interval;
            if (elapsedTime >= maxWaitTime) {
                clearInterval(waitingInterval);
            }
        }
    }, interval);
};

const getTranslation = (key) => {
    const dataEl = document.querySelector('#quick-filters-sp-data');
    return dataEl ? dataEl.dataset[key] : '';
};

const updateQuickFilterStates = () => {
    const isMobile = window.innerWidth < 800;
    let featuresFilters = [];

    if (isMobile) {
        const featureFiltersMobile = document.querySelector("#snize_product_filter_snize_facet4");
        if (featureFiltersMobile) {
            const filters = featureFiltersMobile.querySelectorAll(".snize-product-filters-list li");
            featuresFilters.push(...filters);
        }
    } else {
        const allFilters = document.querySelectorAll(".snize-product-filters-block");
        Array.from(allFilters).forEach((filterContainer) => {
            if (filterContainer.querySelector("span")?.innerText.toLowerCase().includes("feature")) {
                const filters = filterContainer.querySelectorAll(".snize-product-filters-list li");
                featuresFilters.push(...filters);
            }
        });
    }

    const quickFilterButtons = document.querySelectorAll('.quick-filters__filter');

    featuresFilters.forEach((featureFilter, index) => {
        if (quickFilterButtons[index]) {
            const hasCheckedClass = featureFilter.classList.contains('snize-filter-checked');
            const isDisabled = featureFilter.classList.contains('snize-disabled');

            if (hasCheckedClass) {
                quickFilterButtons[index].classList.add('filter-selected');
            } else {
                quickFilterButtons[index].classList.remove('filter-selected');
            }

            if (isDisabled) {
                quickFilterButtons[index].classList.add('filter-disabled');
                quickFilterButtons[index].disabled = true;
            } else {
                quickFilterButtons[index].classList.remove('filter-disabled');
                quickFilterButtons[index].disabled = false;
            }
        }
    });
};

const pollForUpdates = (maxAttempts = 10, interval = 100) => {
    let attempts = 0;
    const pollInterval = setInterval(() => {
        updateQuickFilterStates();
        attempts++;
        if (attempts >= maxAttempts) {
            clearInterval(pollInterval);
        }
    }, interval);
};

const initializeQuickFilters = () => {
    if (window.quickFiltersInitializing) {
        return;
    }
    window.quickFiltersInitializing = true;
    
    let featuresFilters = [];
    const isMobile = window.innerWidth < 800;

    if (isMobile) {
        const featureFiltersMobile = document.querySelector("#snize_product_filter_snize_facet4");
        if (featureFiltersMobile) {
            const filters = featureFiltersMobile.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
            featuresFilters.push(...filters);
        }
    } else {
        const allFilters = document.querySelectorAll(".snize-product-filters-block");
        Array.from(allFilters).forEach((filterContainer) => {
            const spanText = filterContainer.querySelector("span")?.innerText.toLowerCase();
            if (spanText && spanText.includes("feature")) {
                const filters = filterContainer.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
                featuresFilters.push(...filters);
            }
        });
    }

    document.querySelectorAll('.quick-filters__cont').forEach(el => el.remove());

    if (featuresFilters.length > 0) {

        const quickFiltersCont = document.createElement("div");
        quickFiltersCont.className = "quick-filters__cont";
        const titleText = getTranslation('title') || 'Quick Filters:';
        quickFiltersCont.innerHTML = `
            <h3>${titleText}</h3>
            <div class="quick-filters__filters-wrapper">
                <div class="quick-filters__filters">
                ${featuresFilters.map((filter) => {
                const isChecked = filter.classList.contains('snize-filter-checked');
                const isDisabled = filter.classList.contains('snize-disabled');
                return `<button class="quick-filters__filter${isChecked ? ' filter-selected' : ''}${isDisabled ? ' filter-disabled' : ''}"${isDisabled ? ' disabled' : ''}>${filter.querySelectorAll("span")[1].childNodes[0].nodeValue}</button>`;
                }).join("")}
                </div>
            </div>
        `;

        if (isMobile) {
            const mobileTarget = document.querySelector('.snize-selected-filters-container');
            if (mobileTarget) {
                mobileTarget.before(quickFiltersCont);
            }
        } else {
            const desktopTarget = document.querySelector("#snize-search-results-grid-mode");
            if (desktopTarget) {
                desktopTarget.prepend(quickFiltersCont);
            }
        }

        quickFiltersCont.addEventListener('click', (e) => {
            if (e.target.classList.contains('quick-filters__filter')) {
                const quickFilterButtons = quickFiltersCont.querySelectorAll('.quick-filters__filter');
                const index = Array.from(quickFilterButtons).indexOf(e.target);

                let updatedFeatureFilters = [];
                
                if (isMobile) {
                    const featureFiltersMobile = document.querySelector("#snize_product_filter_snize_facet4");
                    if (featureFiltersMobile) {
                        const filters = featureFiltersMobile.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
                        updatedFeatureFilters.push(...filters);
                    }
                } else {
                    const allFiltersUpdated = document.querySelectorAll(".snize-product-filters-block");
                    Array.from(allFiltersUpdated).forEach((filterContainer) => {
                        if (filterContainer.querySelector("span").innerText.toLowerCase().includes("feature")) {
                            const filters = filterContainer.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
                            updatedFeatureFilters.push(...filters);
                        }
                    });
                }

                if (updatedFeatureFilters[index]) {
                    const label = updatedFeatureFilters[index].querySelector('label');
                    if (label) {
                        label.click();
                        
                        if (isMobile) {
                            setTimeout(() => {
                                pollForUpdates();
                            }, 150);
                        } else {
                            pollForUpdates();
                        }
                    }
                }
            }
        });
        featuresFilters.forEach((filterLi) => {
            const label = filterLi.querySelector('label');
            if (label) {
                label.addEventListener('click', () => {
                    pollForUpdates();
                });
            }
        });

        const filterListContainer = isMobile 
            ? document.querySelector("#snize_product_filter_snize_facet4 .snize-product-filters-list")
            : document.querySelector(".snize-product-filters-block:has(span:contains('feature')) .snize-product-filters-list");

        if (!filterListContainer) {
            if (isMobile) {
                const container = document.querySelector("#snize_product_filter_snize_facet4");
                if (container) {
                    const list = container.querySelector(".snize-product-filters-list");
                    if (list) {
                        observeFilterList(list);
                    }
                }
            } else {
                const allFilters = document.querySelectorAll(".snize-product-filters-block");
                Array.from(allFilters).forEach((filterContainer) => {
                    if (filterContainer.querySelector("span")?.innerText.toLowerCase().includes("feature")) {
                        const list = filterContainer.querySelector(".snize-product-filters-list");
                        if (list) {
                            observeFilterList(list);
                        }
                    }
                });
            }
        }
    }
    
    setTimeout(() => {
        window.quickFiltersInitializing = false;
    }, 100);
};

const observeFilterList = (filterList) => {
    if (!filterList || filterList.dataset.quickFilterObserving) return;
    filterList.dataset.quickFilterObserving = 'true';
    
    const filterObserver = new MutationObserver(() => {
        updateQuickFilterStates();
    });

    filterObserver.observe(filterList, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
    });
};

waitForFilters(".snize-product-filters-list .needsclick", () => {
    initializeQuickFilters();

    const isMobile = window.innerWidth < 800;
    
    if (isMobile) {
        const mobileObserverTarget = document.querySelector(".snize-selected-filters-container")?.parentElement;
        if (mobileObserverTarget) {
            let observerTimeout;
            const mobileObserver = new MutationObserver(() => {
                clearTimeout(observerTimeout);
                observerTimeout = setTimeout(() => {
                    const quickFiltersExist = document.querySelector('.quick-filters__cont');
                    const featureFilters = document.querySelector("#snize_product_filter_snize_facet4");
                    
                    if (featureFilters) {
                        const availableFilters = featureFilters.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
                        
                        if (availableFilters.length === 0 && quickFiltersExist) {
                            quickFiltersExist.remove();
                        } else if (availableFilters.length > 0 && !quickFiltersExist) {
                            initializeQuickFilters();
                        } else if (quickFiltersExist) {
                            updateQuickFilterStates();
                        }
                    }
                }, 200);
            });

            mobileObserver.observe(mobileObserverTarget, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }
    } else {
        const observerTarget = document.querySelector("#snize-search-results-grid-mode");
        if (observerTarget) {
            let observerTimeout;
            const observer = new MutationObserver(() => {
                clearTimeout(observerTimeout);
                observerTimeout = setTimeout(() => {
                    const allFilters = document.querySelectorAll(".snize-product-filters-block");
                    let availableFiltersCount = 0;
                    
                    Array.from(allFilters).forEach((filterContainer) => {
                        if (filterContainer.querySelector("span")?.innerText.toLowerCase().includes("feature")) {
                            const availableFilters = filterContainer.querySelectorAll(".snize-product-filters-list li:not(.snize-disabled)");
                            availableFiltersCount = availableFilters.length;
                        }
                    });
                    
                    const quickFiltersExist = document.querySelector('.quick-filters__cont');
                    
                    if (availableFiltersCount === 0 && quickFiltersExist) {
                        quickFiltersExist.remove();
                    } else if (availableFiltersCount > 0 && !quickFiltersExist) {
                        initializeQuickFilters();
                    } else if (availableFiltersCount > 0 && quickFiltersExist) {
                        const currentButtons = quickFiltersExist.querySelectorAll('.quick-filters__filter');
                        if (currentButtons.length !== availableFiltersCount) {
                            initializeQuickFilters();
                        } else {
                            updateQuickFilterStates();
                        }
                    }
                }, 200);
            });

            observer.observe(observerTarget, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }
});